import React, { useCallback, useEffect, useState } from "react";
import { Outlet, NavLink, useNavigate, useLocation, Link } from "react-router-dom";
import HeadingStyle from "../../../components/heading-style/heading-style";
import { Icon, Tab, Tabs } from "@mui/material";
import "./main-settings.scss";
import { connect } from "react-redux";
import { Loading, SubscriptionDetail, UserLogin } from "../../../redux/action";
import { BASE_URL_UI, BASE_URL_WEB, DefaultUserProfile } from "../../../config/config";
import MaterialSymbol from "../../../components/icons/material-symbol";
import { LocalService, SubscriptionService, UserService } from '../../../core/services';
import useBodyClass from "../../../hooks/useBodyClass";
import { AddAPhoto, Expand } from "@mui/icons-material";
import FileUploadPopup from "../../../components/popup/file-upload-popup";
import InstagramIcon from "../../../components/icons/instagram-icon";
import IconYouTube from "../../../components/icons/icon-youtube";
import IconInstagram from "../../../components/icons/icon-instagram";
import { instagramConnectFn } from "../../brand/utlities/social-helper";
import { youtubeConnectFn } from "../../brand/utlities/social-helper-yt";
import { HandlesService } from "../../../core/services/handles.service";
import * as gtUtil from '../../../core/utility'
import { isBrowser, isMobile, isTablet } from "react-device-detect";
import { WhatsApp } from "@mui/icons-material";
import { useIsUSInfluencer } from "../../../hooks/useIsUSInfluencer";

const userService = new UserService();
const handlesService = new HandlesService();
const subscriptionService: SubscriptionService = new SubscriptionService();
const localService = new LocalService();


// interface LinkTabProps {
//   label?: string;
//   href?: string;
// }
interface Props {
  userData: any;
  loading: any;
  updateUser: any;
  updateAccountImage: (data: any) => void;
  SubscriptionDetail: (data: any) => void;
}

const InfluencerSetting: React.FC<Props> = (props: Props) => {
  useBodyClass('mobile-settings')
  const location = useLocation();
  const navigate = useNavigate();
  // US flow hides Company Details, Address and Banking Details from Settings.
  const isUSInfluencer = useIsUSInfluencer();
  const [socialLoading, setSocialLoading] = useState(false);
  const [loadingYt, setLoadingYt] = React.useState(false);
  const [showUploadPopup, setShowUploadPopup] = useState(false);
  const [instagramAccount, setInstagramAccount] = useState([]);
  const [loadingInstagram, setLoadingInstagram] = React.useState(false);
  const [googleaccount, setGoogleAccount] = useState([]);
  const [disconnectButtonGoogle, setDisconnectButtonGoogle] =
    React.useState(true);
  const [connectButtonGoogle, setConnectButtonGoogle] =
    React.useState('Connect');
  const [availablePlan, setAvailablePlan] = useState<any>(null);
  const [planType, setPlanType] = useState('');
  const [activePlan, setActivePlan] = useState<any>(null);
 
  async function getInstagramAccounts() {
    try {
      setLoadingInstagram(true)
      handlesService
        .getConnectedInstagramAccounts(
          props?.userData?.influencer_id
        )
        .then((res: any) => {
          if (res?.data?.rows.length > 0) {
            setInstagramAccount(res?.data?.rows);
          }
        })
        .catch((err: any) => {
          console.log(err)
          setLoadingInstagram(false)
        })
    } catch (err) {
      console.log(err)
      setLoadingInstagram(false)
    } finally {
      setLoadingInstagram(false)
    }
  }

  const getSubscriptionDetail = useCallback(() => {
    //get Subscription Plan Detail
    const { user_id, account_id, account_type, influencer_id } = props.userData;
    async function getSubs() {
      try {
        const response = await subscriptionService.getPlanDetails({
          user_id: user_id,
          account_id: account_id,
          user_type: account_type,
          influencer_id: influencer_id,
        });
        if (response.status === gtUtil.Constants.SUCCESS) {
          //return Only Active Plan Info
          setAvailablePlan(response.data.rows);
          setPlanType(response.data.rows[0].plan_type);
        } else {
          // localService.toastify(response.data.status.message, 'info', 1000);
          setAvailablePlan(null);
        }

        //update subscription Details
        const getPlanDetails: any =
          await subscriptionService.getSubscription_Remaining_Days({
            account_id: props.userData.account_id,
            user_id: props.userData.user_id,
            influencer_id: props.userData.influencer_id
          });

        if (getPlanDetails.status === gtUtil.Constants.SUCCESS) {
          props.SubscriptionDetail(getPlanDetails.data.rows[0]);
        }
      } catch (error) {
        throw new Error(
          `getSubsctiption Detail in Subscription Influencer :: ${JSON.stringify(
            error
          )}`
        );
      }
    }

    async function getActivePlan() {
      try {
        const response: any =
          await subscriptionService.getSubscription_Remaining_Days({
            user_id: user_id,
            account_id: account_id,
            influencer_id: influencer_id
          });
        if (response.status === gtUtil.Constants.SUCCESS) {
          setActivePlan(response.data.rows[0]);
        } else {
          setActivePlan(null);
        }
      } catch (error) {
        console.log(
          `getActivePlan error in influencer Section :: ${JSON.stringify(
            error
          )}`
        );
      }
    }
    getActivePlan();
    getSubs();
  }, [props.userData]);

  useEffect(() => {
    getSubscriptionDetail();
  }, [getSubscriptionDetail]);


  async function getYoutubeAccounts() {
    try {
      setLoadingYt(true)
      handlesService
        .getGoogleConnectedAccounts(
          props?.userData?.influencer_id
        )
        .then((res: any) => {
          if (res?.data?.rows.length > 0) {
            const connectedAccountData = res?.data?.rows.filter(
              (filter: any) => filter.token_status === 'Connected' || filter.token_status === 'Expired'
            );
            setGoogleAccount(connectedAccountData);
            setDisconnectButtonGoogle(false);
            setConnectButtonGoogle('Reconnect');
          }
        })
        .catch((err: any) => console.log(err));
      updateUserReducer();
    } catch (err) {
      console.log(err)
    } finally {
      setLoadingYt(false)
    }
  }
  async function updateUserReducer() {
    let latestUserReducerData = await userService.getUpdatedUserReducer(props.userData);
    if (![undefined, null, ''].includes(latestUserReducerData)) {
      props.updateUser(latestUserReducerData)
    }
  }

  useEffect(() => {
    getInstagramAccounts();
    getYoutubeAccounts();
  }, []);
  const ig: any = instagramAccount?.[0];
  const yt: any = googleaccount?.[0];
  const path = `accounts/${props.userData.account_id}/users`;
  const handleProfilePhoto = async (url: string) => {
    try {
      props.loading(true);

      const payload = {
        ...props.userData,
        photo: url
      };

      // Call update API
      const res = await userService.updateInfluencerDetails(payload);

      if (res.status === 1) {
        // Update redux (important)
        props.updateAccountImage(payload);
      }

    } catch (err) {
      console.error("Profile photo update error", err);
    } finally {
      props.loading(false);
    }
  };
    // Determine device type
  let device = 'laptop'; // default
  if (isMobile) {
    device = 'mobile';
  } else if (isTablet) {
    device = 'tablet';
  } else if (isBrowser) {
    device = 'laptop';
  }
  const pathed = location.pathname.split("/").filter(Boolean);
  const labelMap: Record<string, string> = {
    companydetails: "Company Details",
    "personal-info": "Personal Information",
    userprofile: "User Profile",
    security: "Security",
    shippingaddress: "Shipping Address",
    "subscription-history": "Subscription History",
    paymentmethods: "Banking Details",
    notifications: "Notification Alert",
    community: 'Join Our Community' 

  };
  const lastSegment = pathed[pathed.length - 1];
  const formatted = labelMap[lastSegment] || lastSegment;
  const isRootSettings = location.pathname === "/influencer/settings";
  // const formatted = lastSegment
  //   .replace(/([a-z])([A-Z])/g, "$1 $2") // add space before capital
  //   .replace(/^./, str => str.toUpperCase()); // capitalize first letter
  return (
    <div className="profile_settings_container">
      <div className="mobile-view d-block d-md-none">

        {/* Header */}
        <div className="profile-header">
          <h2>Profile</h2>

          {/* Upload Popup (reuse existing) */}
          {showUploadPopup && (
            <FileUploadPopup
              openModal={showUploadPopup}
              onClose={() => setShowUploadPopup(false)}
              onSend={(e) => handleProfilePhoto(e.url)}
              path={path}
              acceptedFileTypes=".jpg, .jpeg, .png"
            />
          )}
          <div className="profile-user">
            <div className="profile-avatar">
              
              <img
                src={
                  props?.userData?.photo
                    ? props?.userData?.photo
                    : DefaultUserProfile.influencer_unknown_default
                }
              />
              
              <span onClick={() => setShowUploadPopup(true)} className="camera-icon">
                <AddAPhoto fontSize="small" />
              </span>
            </div>

            <div className="pro-badge-title-sec">
              <h3>Hi {props?.userData?.account_name}!</h3>
              {activePlan &&
                <Link to={`${BASE_URL_UI}/influencer/settings/subscription`} className="pro-badge">{activePlan?.remaining_days}</Link>
              }
              {!activePlan && <Link to={`${BASE_URL_UI}/influencer/settings/subscription`} className="pro-badge" style={{color:"#fff"}}>Upgrade</Link>}
            </div>
          </div>
        </div>

        {/* Social Cards */}
        <div className="social-card">
          <div
            className={`social-row ${ig?.username ? "cursor-pointer" : ""}`}
            onClick={() => {
              if (ig?.username) {
                window.open(`${BASE_URL_UI}/brand/profile-insight?sm_id=${ig?.ig_id}&influencerId=${ig?.influencer_id}`, "_blank");
                {/* brand/profile-insight?sm_id=52714&influencerId=62075 */}
              }
            }}
          >

            <div className="icon">
              <IconInstagram width={20} />
              
            </div>
            {ig?.gcp_profile_image_url &&
              <img
              width={36}
              height={36}
              style={{borderRadius:'50%'}}
                src={
                  ig?.gcp_profile_image_url      
                }
              />
              }

            <div className="social-info d-flex flex-column">
              <strong>
                {/* {props.userData?.instagram_username || "Instagram"} */}
                {ig?.insta_name || "Instagram"}

              </strong>
              <p>{ig?.username}</p>

            </div>

            {!ig?.username ? (
              <button
                className="connect-btn"
                onClick={() =>
                  instagramConnectFn(props.userData, props.updateAccountImage, setSocialLoading)
                }
              >
                Connect
              </button>
            ) : (
              ""
            )}

          </div>
          <div
            className={`social-row ${yt?.custom_url ? "cursor-pointer" : ""}`}
            onClick={() => {
              if (yt?.custom_url) {
                window.open(`${BASE_URL_UI}/brand/profile-insight-yt?sm_id=${yt?.yt_id}&influencerId=${yt?.influencer_id}`, "_blank");
              }
            }}
          >
            {/* brand/profile-insight?sm_id=52714&influencerId=62075 */}

            <div className="icon">
              <IconYouTube width={20} />
            </div>
            {yt?.profile_image_url &&
              <img
              width={36}
              height={36}
              style={{borderRadius:'50%'}}
                src={
                  yt?.profile_image_url      
                }
              />
            }
            <div className="social-info">
              <strong>
                {yt?.title || "YouTube"}
              </strong>
              <p>
                {yt?.custom_url}
              </p>
            </div>

            {!yt?.title ? (
              <button
                className="connect-btn"
                onClick={() =>
                  youtubeConnectFn(
                    props.userData,
                    props.updateAccountImage,   // ✅ same as Instagram fix
                    setSocialLoading
                  )
                }
              >
                Connect
              </button>
            ) : (
              ""
            )}

          </div>
        </div>

        {/* Settings */}
        <div className="settings-section">
          <h4>Settings</h4>

          <NavLink to="personal-info" className="settings-item">
            <span className="d-flex items-center">
              <MaterialSymbol iconName="person" fontweight="200" className="me-1" fontSize="20px" />
              Personal Information
            </span>
            <span>
              <MaterialSymbol iconName="chevron_right" fontweight="200" fontSize="20px" />
            </span>
          </NavLink>

          {!isUSInfluencer && (
          <NavLink to="companydetails" className="settings-item">
            <span className="d-flex items-center">
              <MaterialSymbol iconName="business_center" fontweight="200" className="me-1" fontSize="20px" />
              Company Details
            </span>
            <span>
              <MaterialSymbol iconName="chevron_right" fontweight="200" fontSize="20px" />
            </span>
          </NavLink>
          )}

          {!isUSInfluencer && (
          <NavLink to="shippingaddress" className="settings-item">
            <span className="d-flex items-center">
              <MaterialSymbol iconName="location_on" fontweight="200" className="me-1" fontSize="20px" />
              Address
            </span>
            <span>
              <MaterialSymbol iconName="chevron_right" fontweight="200" fontSize="20px" />
            </span>
          </NavLink>
          )}

          <NavLink to="security" className="settings-item">
            <span className="d-flex items-center">
              <MaterialSymbol iconName="lock" fontweight="200" className="me-1" fontSize="20px" />
              Security
            </span>
            <span>
              <MaterialSymbol iconName="chevron_right" fontweight="200" fontSize="20px" />
            </span>
          </NavLink>
          <NavLink className="settings-item" to={"subscription-history"}>
            <span className="d-flex items-center">
              <MaterialSymbol iconName="card_membership" fontweight="200" className="me-1" fontSize="20px" />
              Subscription history
            </span>  
            <span>
              <MaterialSymbol iconName="chevron_right" fontweight="200" fontSize="20px" />
            </span>
          </NavLink>
          {!isUSInfluencer && (
          <NavLink className="settings-item" to={"paymentmethods"}>
            <span className="d-flex items-center">
              <MaterialSymbol iconName="currency_rupee" fontweight="200" className="me-1" fontSize="20px" />
              Banking Details
            </span>
            <span>
              <MaterialSymbol iconName="chevron_right" fontweight="200" fontSize="20px" />
            </span>
          </NavLink>
          )}
          <NavLink className="settings-item" to={"notifications"}>
            <span className="d-flex items-center">
              <MaterialSymbol iconName="notifications" fontweight="200" className="me-1" fontSize="20px" />
              Notification
            </span>
            <span>
              <MaterialSymbol iconName="chevron_right" fontweight="200" fontSize="20px" />
            </span>
          </NavLink>

        </div>

         <div className="settings-section">
          <h4>Support</h4>

          <NavLink to="https://www.clanconnect.ai/faqs" className="settings-item">
            <span className="d-flex items-center">
              <MaterialSymbol iconName="help" fontweight="200" className="me-1" fontSize="20px" />
              FAQ
            </span>
            <span>
              <MaterialSymbol iconName="chevron_right" fontweight="200" fontSize="20px" />
            </span>
          </NavLink>
          <NavLink to="personal-info" className="settings-item">
            <span className="d-flex items-center">
              <MaterialSymbol iconName="mail" fontweight="200" className="me-1" fontSize="20px" />
              Email Us
            </span>
            <span>
              <MaterialSymbol iconName="chevron_right" fontweight="200" fontSize="20px" />
            </span>
          </NavLink>
          <NavLink to="https://api.whatsapp.com/send?phone=9289315858" className="settings-item">
            <span className="d-flex items-center">
              {/* <MaterialSymbol iconName="person" fontweight="200" className="me-1" fontSize="20px" /> */}
              <WhatsApp sx={{ fontSize:'18px', marginRight:'0.25rem'}} />
              Connect via WhatsApp
            </span>
            <span>
              <MaterialSymbol iconName="chevron_right" fontweight="200" fontSize="20px" />
            </span>
          </NavLink>
          <NavLink to="community" className="settings-item">
            <span className="d-flex items-center">
              <MaterialSymbol iconName="groups_3" fontweight="200" className="me-1" fontSize="20px" />
              Join Our Community 
            </span>
            <span>
              <MaterialSymbol iconName="chevron_right" fontweight="200" fontSize="20px" />
            </span>
          </NavLink>

        </div>

         <div className="settings-section">
          <h4>Legal</h4>

          <NavLink to="https://www.clanconnect.ai/terms_condition" className="settings-item">
            <span className="d-flex items-center">
              <MaterialSymbol iconName="article"  fontweight="200" className="me-1" fontSize="20px" />
              Terms &amp; Conditions
            </span>
            <span>
              <MaterialSymbol iconName="chevron_right" fontweight="200" fontSize="20px" />
            </span>
          </NavLink>
          <NavLink to="https://www.clanconnect.ai/privacy_policy/" className="settings-item">
            <span className="d-flex items-center">
              <MaterialSymbol iconName="article"  fontweight="200" className="me-1" fontSize="20px" />
              Privacy Policy
            </span>
            <span>
              <MaterialSymbol iconName="chevron_right" fontweight="200" fontSize="20px" />
            </span>
          </NavLink>
        </div>
        <div className="settings-section mb-5">
          <NavLink to="" className="btn btn-text-link" onClick={() => localService.logout()}>
            <span className="d-flex items-center">  
              Log out
            </span>
          </NavLink>
        </div>
        <div key={location.pathname} className={`mobile-page ${isRootSettings ? 'mobile-page-setting' : ""}`}>
         {device === "mobile" && !isRootSettings && (
              <div className="mobile-header d-md-none">
                <Link to="/influencer/settings">
                  <MaterialSymbol iconName="chevron_left" fontweight="400" fontSize="30px" />
                </Link>
                <span>{formatted}</span>
                
              </div>
            )}
             <>
            {/* ✅ ONLY render outlet for child routes */}
            {!isRootSettings && <Outlet />}
             </>
        </div>

      </div>
      
      <div className="container d-none d-md-block">
        <HeadingStyle title="Profile Settings" className="pb-4 d-block" />
        <div className="row profile_settings_main_container">
          <Tabs
            aria-label="nav tabs example"
            variant="scrollable"
            scrollButtons="auto"
            allowScrollButtonsMobile
            className="nav sub-tabs nav-rounded d-flex d-md-none profile-menu-mobile tab-underline"
            TabIndicatorProps={{ hidden: true }}
          >
            <NavLink className="nav-link" to={"personal-info"}>
              Personal Information
            </NavLink>
            <NavLink className="nav-link" to={"socialconnect"}>
              Social Connect
            </NavLink>
            {!isUSInfluencer && (
            <NavLink className="nav-link" to={"companydetails"}>
              Company Details
            </NavLink>
            )}
            {!isUSInfluencer && (
            <NavLink className="nav-link" to={"shippingaddress"}>
              Address
            </NavLink>
            )}
            <NavLink className="nav-link" to={"security"}>
              Security
            </NavLink>
            <NavLink className="nav-link" to={"subscription"}>
              Subscription
            </NavLink>
            <NavLink className="nav-link" to={"subscription-history"}>
              Subscription history
            </NavLink>
            {!isUSInfluencer && (
            <NavLink className="nav-link" to={"paymentmethods"}>
              Banking Details
            </NavLink>
            )}
            <NavLink className="nav-link" to={"notifications"}>
              Notification
            </NavLink>
          </Tabs>
          <div className="col-md-3 profile_settings_left_side d-none d-md-flex list-section-sidebar flex-column">
            {props.userData?.account_type !== "Talent Partner" ? (
              <>
                <ul className="profile_settings_menu">
                  <li>
                    <NavLink
                      className={
                        "profile_settings_navlinks list-section-sidebar-link"
                      }
                      to={"personal-info"}
                    >
                      Personal Information
                    </NavLink>
                  </li>
                  <li>
                    <NavLink
                      className={
                        "profile_settings_navlinks list-section-sidebar-link"
                      }
                      to={"socialconnect"}
                    >
                      Social Connect
                    </NavLink>
                  </li>
                  {!isUSInfluencer && (
                  <li>
                    <NavLink
                      className={
                        "profile_settings_navlinks list-section-sidebar-link"
                      }
                      to={"companydetails"}
                    >
                      Company Details
                    </NavLink>
                  </li>
                  )}
                  {!isUSInfluencer && (
                  <li>
                    <NavLink
                      className={
                        "profile_settings_navlinks list-section-sidebar-link"
                      }
                      to={"shippingaddress"}
                    >
                      Address
                    </NavLink>
                  </li>
                  )}
                  <li>
                    <NavLink
                      className={
                        "profile_settings_navlinks list-section-sidebar-link"
                      }
                      to={"security"}
                    >
                      Security
                    </NavLink>
                  </li>
                  <li>
                    <NavLink
                      className={
                        "profile_settings_navlinks list-section-sidebar-link"
                      }
                      to={"subscription"}
                    >
                      Subscription
                    </NavLink>
                  </li>
                  <li>
                    <NavLink
                      className={
                        "profile_settings_navlinks list-section-sidebar-link"
                      }
                      to={"subscription-history"}
                    >
                      Subscription history
                    </NavLink>
                  </li>
                  {!isUSInfluencer && (
                  <li>
                    <NavLink
                      className={
                        "profile_settings_navlinks list-section-sidebar-link"
                      }
                      to={"paymentmethods"}
                    >
                      Banking Details
                    </NavLink>
                  </li>
                  )}
                  <li>
                    <NavLink
                      className={
                        "profile_settings_navlinks list-section-sidebar-link"
                      }
                      to={"notifications"}
                    >
                      Notification
                    </NavLink>
                  </li>
                </ul>
                <div className="d-inline-flex flex-wrap">
                  <NavLink
                    className={
                      "profile_settings_navlinks list-section-sidebar-link fs-14 py-0 profile_settings_policy"
                    }
                    to={`${BASE_URL_WEB}/privacy_policy/`}
                    target="_blank"
                  >
                    Privacy Policy
                  </NavLink>
                </div>
              </>
            ) : (
              <>
                <ul className="profile_settings_menu">
                  <li>
                    <NavLink
                      className={
                        "profile_settings_navlinks list-section-sidebar-link"
                      }
                      to={"personal-info"}
                    >
                      Personal Information
                    </NavLink>
                  </li>
                  <li>
                    <NavLink
                      className={
                        "profile_settings_navlinks list-section-sidebar-link"
                      }
                      to={"companydetails"}
                    >
                      Company Details
                    </NavLink>
                  </li>
                  {/* <li>
                    <NavLink
                      className={
                        "profile_settings_navlinks list-section-sidebar-link"
                      }
                      to={"brand-list"}
                    >
                      Talent List
                    </NavLink>
                  </li> */}
                  <li>
                    <NavLink
                      className={
                        "profile_settings_navlinks list-section-sidebar-link"
                      }
                      to={"subscription"}
                    >
                      Subscription
                    </NavLink>
                  </li>
                  <li>
                    <NavLink
                      className={
                        "profile_settings_navlinks list-section-sidebar-link"
                      }
                      to={"subscription-history"}
                    >
                      Subscription history
                    </NavLink>
                  </li>
                  {!isUSInfluencer && (
                  <li>
                    <NavLink
                      className={
                        "profile_settings_navlinks list-section-sidebar-link"
                      }
                      to={"paymentmethods"}
                    >
                      Banking Details
                    </NavLink>
                  </li>
                  )}
                  <li>
                    <NavLink
                      className={
                        "profile_settings_navlinks list-section-sidebar-link"
                      }
                      to={"notifications"}
                    >
                      Notification
                    </NavLink>
                  </li>
                </ul>
                <div className="d-inline-flex flex-wrap">
                  <NavLink
                    className={
                      "profile_settings_navlinks list-section-sidebar-link fs-14 py-0 profile_settings_policy"
                    }
                    to={`${BASE_URL_WEB}/privacy_policy/`}
                    target="_blank"
                  >
                    Privacy Policy
                  </NavLink>
                </div>
              </>
            )}
          </div>

          <div className="col-md-9 profile_settings_right_side">
            <Outlet />
          </div>
        </div>
      </div>
    </div>
  );
};

const mapStateToProps = (state: any) => {
  return {
    userData: state.UserReducer.UserData,
  };
};

const mapDispatchToProps = (dispatch: any) => {
  return {
    loading: (data: any) => dispatch(Loading(data)),
    updateAccountImage: (data: any) => dispatch(UserLogin(data)),
    updateUser: (data: any) => dispatch(UserLogin(data)),
    SubscriptionDetail: (data: any) => dispatch(SubscriptionDetail(data)),
  };
};

const connectToRedux = connect(
  mapStateToProps,
  mapDispatchToProps
)(InfluencerSetting);
export { connectToRedux as InfluencerSetting };
